import React, {Component} from 'react';
import TableView from './views/table-view';
import EditView from './views/edit-view';
import Router from './router';
import director from './director';
import './App.css';
const routes={
    '*':TableView,
    'table-view':TableView,
    'edit-view':EditView
};
class App extends Component{
  constructor(props){
    super(props);
    this.onChange=this.onChange.bind(this);
  }
  componentDidMount() {
    director.on('change', this.onChange);
  }

  componentWillUnmount() {
      director.off('change', this.onChange);
  }

  onChange() {
      console.log("onChange");
      this.forceUpdate();
  }
  render() {
    const setView = director.setView;
    const getView = director.getView;
    return(
      <div>
        <h1> Gestor de usuarios DUCT5</h1>
        <div>
          <Router
            routes={routes}
            getView={getView}/>

        </div>
      </div>
    )
  }
  
}


export default App;
